import PropTypes from 'prop-types';
import { LoadingSpinner as EtiLoadingSpinner } from '@eti/components';
import { InView } from 'react-intersection-observer';
import { css } from '@eti/styles';

const wrapper = css`
  display: flex;
  justify-content: center;
  margin: 30px auto;
`;

const LoadingSpinner = ({ setFetchMoreResults }) => {
  const loadMore = (inView) => {
    if (inView) {
      setFetchMoreResults(true);
    }
  };

  return (
    <InView as="div" className={wrapper} data-testid="loadingSpinnerWrapper" onChange={loadMore}>
      <EtiLoadingSpinner />
    </InView>
  );
};

LoadingSpinner.propTypes = {
  setFetchMoreResults: PropTypes.func,
};

export default LoadingSpinner;
